import Vue from "vue";
import Element from "element-ui";
import App from "@/App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import "@/icons";
import "@/element-ui/theme/index.css";
import "@/assets/scss/aui.scss";
import http from "@/utils/request";
import renRadioGroup from "@/components/ren-radio-group";
import renSelect from "@/components/ren-select";
import renDeptTree from "@/components/ren-dept-tree";
import renRegionTree from "@/components/ren-region-tree";
import { hasPermission, getDictLabel } from "@/utils";
import cloneDeep from "lodash/cloneDeep";
import { unblank } from "@/utils/methods";
import wCity from "@/components/my-city/city.vue";
import wList from "@/components/my-compnay/index.vue"
import wPickers from "@/components/w-pickers/index.vue"
import * as echarts from 'echarts';
/**
 * v-debounceClick="handleFun"
 * delayTime:延迟的时间,只执行最后一次
 */
import { Debounce } from './utils/tools'

Vue.directive('debounceClick', {
  bind(el, binding, vnode, oldvnode) {},
  inserted: function (el, binding) {
    let delayTime = el.getAttribute('delay-time') || 1500//设置延时时间，传入时间是为传入时间，否则默认
    el.onclick = Debounce(function () {
      binding.value()
    }, delayTime)
  },
})
Vue.config.productionTip = false;
Vue.component('wCity',wCity)
Vue.component('wList',wList)
Vue.component('wPickers',wPickers)
Vue.use(Element, {
  size: "default",
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(renRadioGroup);
Vue.use(renSelect);
Vue.use(renDeptTree);
Vue.use(renRegionTree);


// 挂载全局
Vue.prototype.$http = http;
Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$getDictLabel = getDictLabel;
Vue.prototype.$unblank = unblank
Vue.prototype.$echarts = echarts

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG["storeState"] = cloneDeep(store.state);

new Vue({
  beforeCreate() {
    Vue.prototype.$bus = this  //全局安装配置全局事件总线
  },
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
